import { playSound, Sound } from '~/assets/sounds';
import { StyledCircle, StyledRect, StyledSvg } from './Switch.styled';

interface IStatusIconProps extends React.HTMLAttributes<SVGElement> {
	active: boolean;
}

const Switch: React.FC<IStatusIconProps> = ({
	active,
	...props
}: IStatusIconProps) => {
	return (
		<StyledSvg
			width="30"
			height="20"
			viewBox="0 0 30 20"
			fill="white"
			xmlns="http://www.w3.org/2000/svg"
			onMouseEnter={() => playSound(Sound.LinkCursor)}
			onClick={() => playSound(Sound.ClickButton)}
			{...props}
		>
			<StyledRect $active={active} width="30" height="20" rx="10" />
			<StyledCircle $active={active} cx="20" cy="10" r="5" />
		</StyledSvg>
	);
};

export { Switch };
